export default {
  label: "Fleet Management",
};
